module.exports = __webpack_public_path__ + "img/dsci0071.202e37d4.jpg";